module.exports = __webpack_public_path__ + "img/is.2c2c2b7d.svg";